<div
  class="backgroundLogin"
  [ngClass]="{ backgroundEffect: backEffect }"
  [style.background-image]="
    'url(./assets/img/' + customTheme + '/imagesLogin/' + img + ')'
  "
></div>
<div class="container-recover">
    <mat-card class="recover-card">
        <img id="tower-img" class="login-logo" [src]="logoUrl" />
        <div *ngIf="!mailResult">
            <p class="title text-center">{{ 'gGkr9ViT19cTjtfR27TfMD' | translate }}</p>
            <!-- Token: Sign up on the portal -->
            <p class="content text-left">{{ 'rdBiNib29kTmYeXrRwwn8U' | translate }}</p>
            <!-- Token: Please provide your email address to access the client portal. -->
            <form [formGroup]="form" (ngSubmit)="onSendEmail()" class="form-recover">
            <mat-form-field>
                <input
                matInput
                placeholder="{{ 'k000079' | translate }}"
                type="text"
                formControlName="user"
                class="ipt-item"
                />
            </mat-form-field>
            <button
                #btnSend
                color="primary"
                type="submit"
                [disabled]="form.invalid"
                class="buttonPortal btn-send-email"
            >
                <span *ngIf="!faSpinner">{{ 'k000018' | translate }}</span
                ><!-- Token: Enviar -->
                <fa-icon [icon]="faSpinner" [spin]="true" *ngIf="faSpinner"></fa-icon>
            </button>
            </form>
        </div>
        <div *ngIf="mailResult">
            <p class="title text-center">{{ 'gGkr9ViT19cTjtfR27TfMD' | translate }}</p>
            <!-- Token: Sign up on the portal-->
            <p class="content text-center">{{ 'k8CXA8joercAsyYrn8kNT3' | translate }}</p>
            <!-- Token: Request processed! We have sent you an email with instructions to access the portal. Please check your inbox and your spam folder. -->
        </div>
        <a class="recover-back" routerLink="/login">{{ 'k001838' | translate }}</a>
        <!-- Token: Back to mainpage -->
    </mat-card>
</div>
